import PendingInvestment from './PendingInvestment';

export default PendingInvestment;
